import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type FavoriteState = {
  items: string[];
  max: number;
  add: (id: string) => void;
  remove: (id: string) => void;
  toggle: (id: string) => void;
  clear: () => void;
};

const noopStorage: Storage = {
  getItem: () => null,
  setItem: () => { },
  removeItem: () => { },
  key: () => null,
  length: 0,
};

export const useFavoriteStore = create<FavoriteState>()(
  persist(
    (set, get) => ({
      items: [],
      max: 1000,
      add: (id) =>
        set((state) => {
          if (state.items.includes(id)) return state;
          if (state.items.length >= state.max) return state;
          return { items: [...state.items, id] };
        }),
      remove: (id) =>
        set((state) => ({ items: state.items.filter((x) => x !== id) })),
      toggle: (id) => {
        const { items } = get();
        if (items.includes(id)) {
          get().remove(id);
        } else {
          get().add(id);
        }
      },
      clear: () => set({ items: [] }),
    }),
    {
      name: "favorites",
      storage: createJSONStorage(() =>
        typeof window !== "undefined" ? localStorage : noopStorage
      ),
      partialize: (state) => ({ items: state.items, max: state.max }),
    }
  )
);

// Cross-tab sync
if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === "favorites") {
      try {
        const parsed = e.newValue ? JSON.parse(e.newValue) : null;
        const items = parsed?.state?.items ?? [];
        useFavoriteStore.setState({ items });
      } catch {
        // ignore
      }
    }
  });
}
